<template>
	<base-title>Dashbard</base-title>

	<!-- Search and Export -->
	<MDBContainer fluid>
		<MDBRow class="justify-content-between px-4 mb-4">
			<MDBCol col="6">
				<!-- Search Field (Left) -->
				<div class="search-wrapper">
					<div class="input-group">
						<span class="input-group-text">
							<i class="fas fa-search"></i>
						</span>
						<input
							type="text"
							class="form-control"
							placeholder="Пошук... (Spotify Netflix або Spotify, Netflix)"
							v-model="searchQuery"
						/>
						<button
							v-if="searchQuery"
							class="btn btn-outline-secondary"
							type="button"
							@click="searchQuery = ''"
						>
							<i class="fas fa-times"></i>
						</button>
					</div>
					<small v-if="searchQuery" class="text-muted mt-1 d-block">
						Знайдено: {{ filteredData.length }} з {{ (sortedData || currentData)?.length || 0 }}
					</small>
					<small v-else class="text-muted mt-2 d-flex">
						<i class="fas fa-info-circle me-2"></i> Використовуйте пробіл або кому для пошуку кількох слів (OR)
					</small>
				</div>
			</MDBCol>
			<MDBCol col="4" class="d-flex justify-content-end">
					<!-- Export Button (Right) -->
					<div class="export-wrapper">
						<button
							class="btn btn-success"
							@click="exportToExcel"
							:disabled="!displayData || displayData.length === 0"
						>
							Експорт в Excel
						</button>
					</div>
			</MDBCol>

		</MDBRow>
	</MDBContainer>
	<div class="table-responsive">
		<table
			class="table table-striped table-hover table-sm table-light border-secondary"
		>
			<thead>
				<tr>
					<th
						scope="col"
						@click="
							sortData('currencyCode', currencyCodeOrder);
							currencyCodeOrder = !currencyCodeOrder;
						"
					>
						Назва
						<i
							class="fas mx-3"
							:class="
								!!currencyCodeOrder
									? ' fa-caret-down'
									: ' fa-caret-up'
							"
						></i>
					</th>
					<th
						scope="col"
						@click="
							sortData('time', timeOrder);
							timeOrder = !timeOrder;
						"
					>
						Дата, час
						<i
							class="fas mx-3"
							:class="
								!!timeOrder ? ' fa-caret-down' : ' fa-caret-up'
							"
						></i>
					</th>
					<th
						scope="col"
						@click="
							sortData('mcc', mccOrder);
							mccOrder = !mccOrder;
						"
					>
						Код
						<i
							class="fas mx-3"
							:class="
								!!mccOrder ? ' fa-caret-down' : ' fa-caret-up'
							"
						></i>
					</th>
					<th
						scope="col"
						@click="
							sortData('amount', operationAmountOrder);
							operationAmountOrder = !operationAmountOrder;
						"
					>
						Сума
						<i
							class="fas mx-3"
							:class="
								!!operationAmountOrder
									? ' fa-caret-down'
									: ' fa-caret-up'
							"
						></i>
					</th>
					<th
						scope="col"
						@click="
							sortData('commissionRate', commissionRateOrder);
							commissionRateOrder = !commissionRateOrder;
						"
					>
						Коміссія
						<i
							class="fas mx-3"
							:class="
								!!commissionRateOrder
									? ' fa-caret-down'
									: ' fa-caret-up'
							"
						></i>
					</th>
					<th
						scope="col"
						@click="
							sortData('balance', balanceOrder);
							balanceOrder = !balanceOrder;
						"
					>
						Залишок
						<i
							class="fas mx-3"
							:class="
								!!balanceOrder
									? ' fa-caret-down'
									: ' fa-caret-up'
							"
						></i>
					</th>
					<th
						scope="col"
						@click="
							sortData('cashbackAmount', cashbackAmountOrder);
							cashbackAmountOrder = !cashbackAmountOrder;
						"
					>
						Кешбек
						<i
							class="fas mx-3"
							:class="
								!!cashbackAmountOrder
									? ' fa-caret-down'
									: ' fa-caret-up'
							"
						></i>
					</th>
				</tr>
			</thead>
			<tbody v-if="!isLoading && !dataIsEmpty">
				<the-item
					v-for="row in displayData"
					:key="row.id"
					v-bind="row"
					:search-query="searchQuery"
				></the-item>
			</tbody>
			<tbody v-if="isLoading && !dataIsEmpty">
				<tr>
					<td colspan="7">
						<base-spinner></base-spinner>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
	<div
		v-if="dataIsEmpty || dataHasError"
		class="t-message py-3 px-4 text-center rounded mx-auto mt-3 text-dark fw-light fs-6"
	>
		<p class="mb-0">Ooops, there is some issue...</p>
		<p class="mb-0">The database is empty or you do not have permission</p>
	</div>
</template>

<script>
import {
	MDBContainer,
	MDBRow,
	MDBCol
} from "mdb-vue-ui-kit";
import * as XLSX from 'xlsx';
import TheItem from "./TheItem.vue";

export default {
	components: {
		TheItem,
		MDBRow,
		MDBContainer,
		MDBCol,
	},
	data() {
		return {
			isLoading: false,
			currentData: null, // TODO: cleare when user logout
			sortedData: null,
			searchQuery: '',
			currencyCodeOrder: true,
			timeOrder: true,
			mccOrder: true,
			operationAmountOrder: true,
			commissionRateOrder: true,
			balanceOrder: true,
			cashbackAmountOrder: true,
			dataIsEmpty: false,
			dataHasError: false,
		};
	},
	computed: {
		filteredData() {
			const data = this.sortedData || this.currentData;
			if (!data || !this.searchQuery) return data;

			// Розбиваємо пошуковий запит на окремі терміни (по пробілу або комі)
			const searchTerms = this.searchQuery
				.split(/[\s,]+/) // Розділяємо по пробілу або комі
				.map(term => term.trim().toLowerCase()) // Очищаємо і приводимо до нижнього регістру
				.filter(term => term.length > 0); // Видаляємо порожні рядки

			if (searchTerms.length === 0) return data;

			return data.filter(item => {
				// Створюємо рядок з усіма значеннями транзакції
				const searchableText = [
					item.currencyCode || '',
					this.formatDateForSearch(item.time) || '',
					String(item.mcc || ''),
					this.formatAmount(item.amount),
					this.formatAmount(item.commissionRate),
					this.formatAmount(item.balance),
					this.formatAmount(item.cashbackAmount)
				].join(' ').toLowerCase();

				// Перевіряємо чи хоча б один термін знайдено (OR логіка)
				return searchTerms.some(term => searchableText.includes(term));
			});
		},
		displayData() {
			return this.filteredData;
		}
	},
	created() {
		return this.loadData();
	},
	methods: {
		async loadData() {
			this.isLoading = true;

			// this.$store.dispatch("test");

			try {
				await this.$store.dispatch("downloadData");
			} catch (error) {
				this.error = error.message || "Something went wrong";
			}

			this.dataHasError = await this.$store.getters[
				"getDatabaseErrorState"
			];
			this.dataIsEmpty = await this.$store.getters["getDatabaseFilling"];

			if (!this.dataHasError && !this.dataIsEmpty) {
				this.currentData = await this.$store.getters["currentData"];
				this.sortData("time", this.timeOrder);
				this.timeOrder = !this.timeOrder;
			}

			this.isLoading = false;
		},
		sortData(value, sortOrder) {
			// Створюємо копію масиву, щоб не мутувати оригінальні дані
			this.sortedData = [...this.currentData].sort((a, b) => {
				// Перевірка чи існують ключі
				if (!Object.prototype.hasOwnProperty.call(a, value) || !Object.prototype.hasOwnProperty.call(b, value)) {
					return 0;
				}

				let aVal = a[value];
				let bVal = b[value];

				// Для рядків приводимо до верхнього регістру
				if (typeof aVal === 'string') {
					aVal = aVal.toUpperCase();
					bVal = bVal.toUpperCase();
				}

				// Порівняння
				if (aVal > bVal) return sortOrder ? 1 : -1;
				if (aVal < bVal) return sortOrder ? -1 : 1;
				return 0;
			});
		},
		formatDateForSearch(timestamp) {
			if (!timestamp) return '';
			return new Date(timestamp * 1000).toLocaleString('uk-UA', {
				timeZone: 'Europe/Kiev'
			}).toLowerCase();
		},
		formatDateForExport(timestamp) {
			if (!timestamp) return '';
			return new Date(timestamp * 1000).toLocaleString('uk-UA', {
				day: '2-digit',
				month: '2-digit',
				year: 'numeric',
				hour: '2-digit',
				minute: '2-digit',
				second: '2-digit',
				timeZone: 'Europe/Kiev'
			});
		},
		formatAmount(value) {
			if (!value && value !== 0) return '';
			return (value / 100).toFixed(2);
		},
		exportToExcel() {
			if (!this.displayData || this.displayData.length === 0) {
				return;
			}

			// Підготовка даних у тому ж порядку стовпців що в таблиці
			const exportData = this.displayData.map(item => ({
				'Назва': item.currencyCode || '',
				'Дата, час': this.formatDateForExport(item.time),
				'Код': item.mcc || '',
				'Сума': this.formatAmount(item.amount),
				'Коміссія': this.formatAmount(item.commissionRate),
				'Залишок': this.formatAmount(item.balance),
				'Кешбек': this.formatAmount(item.cashbackAmount)
			}));

			// Створення робочої книги
			const worksheet = XLSX.utils.json_to_sheet(exportData);
			const workbook = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(workbook, worksheet, 'Транзакції');

			// Генерація імені файлу з поточною датою
			const date = new Date().toISOString().split('T')[0];
			const fileName = `transactions_${date}.xlsx`;

			// Експорт файлу
			XLSX.writeFile(workbook, fileName);
		},
	},
};
</script>

<style lang="scss" scoped>
th {
	vertical-align: top;
}
i {
	display: block;
	margin-top: 5px;
}
.t-message {
	background-color: rgba(29, 233, 182, 0.15);
	border-left: 4px solid rgba(98, 0, 234, 0.55);
	max-width: 650px;
	width: 90%;
}

.controls-container {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	gap: 1rem;
	margin-bottom: 1.5rem;

	.search-wrapper {
		flex: 0 1 500px;
		min-width: 250px;

		.input-group {
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
			border-radius: 0.375rem;

			.input-group-text {
				background-color: #f8f9fa;
				border-right: none;
			}

			.form-control {
				border-left: none;
				&:focus {
					border-color: #dee2e6;
					box-shadow: none;
				}
			}

			.btn {
				border-left: none;
			}
		}
	}

	.export-wrapper {
		flex-shrink: 0;

		.btn {
			white-space: nowrap;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		}
	}

	@media (max-width: 768px) {
		flex-direction: column;
		align-items: stretch;

		.search-wrapper {
			flex: 1 1 auto;
		}

		.export-wrapper {
			.btn {
				width: 100%;
			}
		}
	}
}
</style>
